export const selectCurrentUser = state => state.user.currentUser